import { Tooltip } from '@/components/ui/custom/dataDisplay/Tooltip';
import { Button } from '@/components/ui/daisy';
import useScheduledLessonSubmitBtn from '@/data/hook/scheduled-lesson-report/useScheduledLessonSubmitBtn';
import useSubmitBtnStyles from '@/data/hook/scheduled-lesson-report/useSubmitBtnStyles';
import { ListCacheManager } from '@/data/hook/query/v2/CacheFacade';
import Klass from '@/models/Klass';
import ScheduledLesson from '@/models/ScheduledLesson';

type SubmitScheduledLessonBtnProps = {
  scheduledLesson: ScheduledLesson;
  klass: Klass;
  cacheManager?: ListCacheManager<ScheduledLesson>;
};

export default function SubmitScheduledLessonBtn({
  scheduledLesson,
  klass,
  cacheManager,
}: SubmitScheduledLessonBtnProps) {
  const { hasDone, isUpdating, onSubmit } = useScheduledLessonSubmitBtn({
    scheduledLesson,
    klass,
    cacheManager,
  });

  const { color, variant, text, icon, tooltipMessage, isLocked } =
    useSubmitBtnStyles({ scheduledLesson, klass, hasDone });

  return (
    <Tooltip
      text={tooltipMessage}
      enable={!!tooltipMessage}
      placement="top"
      classNameContainer="flex flex-1 w-full"
    >
      <Button
        className="flex-1 w-full"
        color={color}
        variant={variant}
        disabled={isLocked}
        loading={isUpdating}
        onClick={onSubmit}
      >
        {icon}
        {text}
      </Button>
    </Tooltip>
  );
}
